import { render, staticRenderFns } from "./scrollPrize.vue?vue&type=template&id=62780c4c&scoped=true"
import script from "./scrollPrize.vue?vue&type=script&lang=js"
export * from "./scrollPrize.vue?vue&type=script&lang=js"
import style0 from "./scrollPrize.vue?vue&type=style&index=0&id=62780c4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62780c4c",
  null
  
)

export default component.exports